import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import Cooladata from 'src/components/common/Cooladata';
import Credits from 'src/components/common/Credits';
import Banner from 'src/components/common/Banner';
import { HeroForm } from './HeroForm';

import heroImg from './assets/hero.svg';
import css from './Main.module.scss';

const texts = {
  // heroDesktop: `כמה זמן מחייכם ומחיי ילדיכם עברו בזמן מלחמות, מבצעים צבאיים ופעולות איבה?`,
  heroDesktop: `כמה זמן מהחיים שלכם ושל הילדים שלכם<br />עברו בזמן מלחמות, מבצעים צבאיים ופעולות איבה?`,
  heroMobile: `כמה זמן מהחיים שלכם ושל הילדים שלכם<br />עברו בזמן מלחמות, מבצעים צבאיים<br />ופעולות איבה?`,
};

export const Main = () => {
  const [bannerRef, setBannerRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    setBannerRef(document.getElementById('mainBanner') as HTMLDivElement);
  }, []);

  return (
    <>
      {bannerRef && createPortal(<Banner />, bannerRef)}
      <div className={css.main}>
        <Cooladata pageId="HP" />
        <div className={css.hero}>
          <img className={css.heroImg} src={heroImg} alt="" />
          <div className={css.heroContent}>
            <h1 className={css.desktop} dangerouslySetInnerHTML={{ __html: texts.heroDesktop }} />
            <h1 className={css.mobile} dangerouslySetInnerHTML={{ __html: texts.heroMobile }} />
            <HeroForm />
          </div>
        </div>
        <Credits />
      </div>
      <div className={css.resultsFontPreloader}>0</div>
    </>
  );
};
